import { ViewerSessionsTable } from '@components/viewer-sessions';
import { isDrilldownFeatureByMetric } from '@components/viewer-sessions/utils';
import { getFirstAppliedFilter } from '@store/common/selectors';
import { selectedMetricSelector } from '@store/metricsChartContainer/selectors';
import { chartIntervalSelector } from '@store/trends/birdChart/selectors';
import React from 'react';
import { useSelector } from 'react-redux';
import { ViewerSessionWrapper, VMTitle, WarningText } from './styled';
import { tid } from '@utils/test';
import ViewerControls from './ViewerControls';

function ViewerSessions() {
  const filter = useSelector(getFirstAppliedFilter);
  const interval = useSelector(chartIntervalSelector);
  const metric = useSelector(selectedMetricSelector);

  if (!isDrilldownFeatureByMetric(metric)) {
    return <WarningText>Viewer Sessions is not available for the selected metric.</WarningText>;
  }

  return (
    <ViewerSessionWrapper {...tid('viewer-sessions')}>
      <VMTitle>
        <div style={{ flex: 1 }}>{`Subset of Viewer Sessions (up to 1500)`}</div>
        <ViewerControls />
      </VMTitle>
      <ViewerSessionsTable filter={filter.rule} interval={interval} viewerDrillDownKey={'trends'} />
    </ViewerSessionWrapper>
  );
}

export default ViewerSessions;
